import toDate from'../toDate/index.js';import requiredArgs from'../_lib/requiredArgs/index.js';/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now, `closestIndexTo` doesn't throw an exception
 *   when the second argument is not an array, and returns Invalid Date instead.
 *
 * @param {Date|Number} dateToCompare - the date to compare with
 * @param {Date[]|Number[]} datesArray - the array to search
 * @returns {Number} an index of the date closest to the given date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * var dateToCompare = new Date(2015, 8, 6)
 * var datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * var result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */export default function closestIndexTo(dirtyDateToCompare,dirtyDatesArray){requiredArgs(2,arguments);var dateToCompare=toDate(dirtyDateToCompare);if(isNaN(dateToCompare)){return NaN;}var timeToCompare=dateToCompare.getTime();var datesArray;// `dirtyDatesArray` is undefined or null
if(dirtyDatesArray==null){datesArray=[];// `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
}else if(typeof dirtyDatesArray.forEach==='function'){datesArray=dirtyDatesArray;// If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
}else{datesArray=Array.prototype.slice.call(dirtyDatesArray);}var result;var minDistance;datesArray.forEach(function(dirtyDate,index){var currentDate=toDate(dirtyDate);if(isNaN(currentDate)){result=NaN;minDistance=NaN;return;}var distance=Math.abs(timeToCompare-currentDate.getTime());if(result==null||distance<minDistance){result=index;minDistance=distance;}});return result;}